<template src="./template.html"></template>

<script>
  export default {
    name: 'LoginOverlay',
    components: {
      LoginPage: () => import('@/views/authPages/LoginPage'),
    },
    data() {
      return {
        isOpen: true,
      }
    },
    computed: {
      opened: {
        set() {
          this.isOpen = false
        },
        get() {
          return this.isOpen
        },
      },
    },
  }
</script>
